import { Alert, Avatar, Box, Button, Card, CircularProgress, Grid, IconButton, Snackbar, TextField, Typography, useTheme } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { authActions } from "../../store/reducer/auth-reducer";
import { Link, useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import AlertBar from "../../components/AlertBar";
import { homePageActions } from "../../store/reducer/home";
import { ReactComponent as Logo } from '../../assets/logo.svg';
import CmmKolkataLogo from "../../components/CmmKolkataLogo";
import AuthService from "../../store/api/auth-api";
const defRegister: any = {
    app_key: "@34Y@#8deepmatka",
    name: '',
    mobile: '',
    password: '',
}

const Register = ({ isRegisterSuccess, isPageLoading, pageMessage, isRegisterFailed, isAuthenticated, userData }: any) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useTheme();
    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })
    const [registerData, setRegisterData] = useState<any>(defRegister)
    const [isCheckingMobile, setIsCheckingMobile] = useState(false)

    useEffect(() => {
        const pay: any = {
            menuname: 'starline'
        }
        dispatch(homePageActions.selectedMenu(pay))
    }, [])

    const handleOnChange = (event: any) => {
        setRegisterData((prev: any) => {
            return { ...prev, [event.target.name]: event.target.value }
        })
    }
    const handleLogin = async (event: any) => {
        event.stopPropagation();
        if (registerData.name.trim().length === 0) {
            setErrorMessage({ status: true, message: "Please enter valid name", severity: 'warning', inputName: 'name' })
        } else if (registerData.mobile.trim().length === 0) {
            setErrorMessage({ status: true, message: "Please enter mobile number", severity: 'warning', inputName: 'mobile' })
        } else if (registerData.mobile.trim().length !== 10) {
            setErrorMessage({ status: true, message: "Please enter valid 10 digit mobile number", severity: 'warning', inputName: 'mobile' })
        } else if (registerData.password.trim().length === 0) {
            setErrorMessage({ status: true, message: "Please enter valid password", severity: 'warning', inputName: 'password' })
        } else {
            setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
            setIsCheckingMobile(true)
            
            // Check if mobile number is already registered
            try {
                const checkMobilePayload = {
                    app_key: "@34Y@#8deepmatka",
                    mobile: registerData.mobile.trim()
                };
                const result = await AuthService.checkMobile(checkMobilePayload);
                setIsCheckingMobile(false);
                
                // If API returns status: false, it means mobile is already registered
                if (result.status === 'failed' || !result.res.status) {
                    setErrorMessage({ 
                        status: true, 
                        message: result.res.msg || "Mobile number is already registered. Please try login.", 
                        severity: 'error', 
                        inputName: 'mobile' 
                    });
                } else {
                    // Mobile is not registered, proceed with registration
                    dispatch(authActions.checkRegister({ ...registerData, email: '', security_pin: '' }))
                }
            } catch (error) {
                setIsCheckingMobile(false)
                setErrorMessage({ status: true, message: "Error checking mobile number. Please try again.", severity: 'error', inputName: 'mobile' })
            }
        }
    }


    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };

    useEffect(() => {
        if (isRegisterSuccess) {
            setRegisterData(defRegister)
            setErrorMessage({ status: true, message: pageMessage, severity: "success", inputName: '' })
            localStorage.setItem('isAuthenticated', isAuthenticated);
            localStorage.setItem('userData', JSON.stringify(userData));
            const data: any = { "app_key": "@34Y@#8deepmatka", "user_id": userData.user_id }
            dispatch(authActions.getUserDataReq(data))
            dispatch(authActions.getWalletBalanceReq(data))
            navigate('/')
        }

        if (isRegisterFailed) {
            setErrorMessage({ status: true, message: pageMessage, severity: "error", inputName: 'mobile' })
            setRegisterData(defRegister)
        }
        // return(()=>{
        //     setErrorMessage({ status: false, message: "", severity: "", inputName:'' })
        //     dispatch(authActions.resetLoginState())
        // })
    }, [isRegisterSuccess, isRegisterFailed, isAuthenticated])

    return (
        <Grid container sx={{ backgroundColor: theme.palette.background.default, marginTop: '80px' }} >
            <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
            <Grid xs={12} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
                <Box sx={{ marginBottom: '30px', marginTop: '20px' }}>
                    <CmmKolkataLogo style={{ transform: 'scale(1.5)' }} />
                </Box>
                <Card sx={{ 
                    display: 'flex', 
                    boxShadow: theme.shadows[6], 
                    border: `2px solid ${theme.palette.divider}`, 
                    flexDirection: 'column', 
                    alignItems: "center", 
                    justifyContent: 'center', 
                    gap: 2, 
                    padding: '40px',
                    backgroundColor: theme.palette.background.paper,
                    borderRadius: '24px',
                }}>
                    <Box>
                        <Avatar sx={{ 
                            width: '100px', 
                            height: '100px',
                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                        }} />
                    </Box>
                    <Typography sx={{ 
                        fontSize: '24px',
                        fontWeight: 700,
                        color: theme.palette.text.primary,
                        fontFamily: 'Poppins',
                    }}>Register</Typography>
                    {Object.keys(defRegister).map((item: any, index: number) => (
                        item != 'app_key' && <TextField sx={{ 
                            width: "100%",
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: theme.palette.divider,
                                },
                                '&:hover fieldset': {
                                    borderColor: theme.palette.primary.main,
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: theme.palette.primary.main,
                                },
                            },
                        }} label={(item === 'security_pin') ? item.replace('_', ' ').toUpperCase() : item.toUpperCase()} name={item} variant="outlined" defaultValue="" type={(item === 'password' || item === 'security_pin') ? 'password' : 'text'} error={(errorMessage.inputName === item) ? errorMessage.status ? errorMessage.message : '' : ''} helperText={(errorMessage.inputName === item) ? errorMessage.status ? errorMessage.message : '' : ''} onChange={handleOnChange} />
                    ))}


                    <Button 
                        variant="contained" 
                        disabled={isCheckingMobile || isPageLoading}
                        sx={{
                            width: "100%", 
                            boxShadow: theme.shadows[4],
                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                            color: '#FFFFFF',
                            fontWeight: 600,
                            fontSize: '1rem',
                            padding: '12px',
                            '&:hover': {
                                boxShadow: theme.shadows[6],
                                transform: 'translateY(-2px)',
                            },
                            '&:disabled': {
                                background: theme.palette.action.disabledBackground,
                                color: theme.palette.action.disabled,
                            },
                            transition: 'all 0.3s ease',
                        }} 
                        color="primary" 
                        onClick={handleLogin}
                    >
                        {isCheckingMobile ? 'Checking Mobile...' : isPageLoading ? 'Registering...' : 'Register'}
                    </Button>
                    {(isCheckingMobile || isPageLoading) && <CircularProgress sx={{ color: theme.palette.primary.main, marginTop: '10px' }} />}
                    <Typography sx={{ 
                        display: 'flex', 
                        width: "100%", 
                        color: theme.palette.text.secondary, 
                        flexDirection: "row", 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        fontSize: '0.9rem',
                    }}>Have an account? &nbsp;<Typography sx={{ 
                        fontWeight: 'bold', 
                        cursor: 'pointer', 
                        color: theme.palette.primary.main,
                        '&:hover': {
                            textDecoration: 'underline',
                        }
                    }} onClick={() => { navigate('/login') }}> Login here </Typography></Typography>
                </Card>

            </Grid>
        </Grid>
    )
}



const mapStateToProps = (state: any) => ({
    isRegisterSuccess: state.authentication.isRegisterSuccess,
    isPageLoading: state.authentication.isPageLoading,
    pageMessage: state.authentication.pageMessage,
    userData: state.authentication.userData,
    isRegisterFailed: state.authentication.isRegisterFailed,
    isAuthenticated: state.authentication.isAuthenticated,
})


export default connect(mapStateToProps)(Register);
